import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {AccountUserStatusKind} from '../enum/account.user.status.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {AccountEntity} from './account.entity';
import {PersonEntity} from './person.entity';

@EntityTable('account_user_xref', 'b382c888-1d05-45ec-b0e3-cc2e10bee8f7')
export class AccountUserXrefEntity extends Entity {

    @JoinColumn(FieldTypeKind.GUID, AccountEntity, false, false, FieldRelationKind.BELONGS_TO, 'account')
    public accountId: string;

    @Column(FieldTypeKind.GUID)
    public userId: string;

    @Column(FieldTypeKind.LONG)
    public status: AccountUserStatusKind;

    @JoinColumn(FieldTypeKind.GUID, PersonEntity, true, false, FieldRelationKind.BELONGS_TO, 'person')
    public personId: string;
}
